import React, {useEffect, useCallback} from 'react';
import {getAllTags} from './getAllTags.js';
import {addTag} from './sidebarAdd.js';
import {DEFAULT_TAGS} from './constants.js';
import {nameToEffect} from 'effects/EffectsList.js';
import {nameToMidiEffect} from 'effects/midi/getMidiEffect.js';
import {getEffectPresets} from 'decentralized/effects/EffectPresets.js';

let CACHED_PRESETS = undefined;
let counter=0;
const WAIT_TIME = 200;

export const useSearcher = ({
    setTags,
    setEffects,
    effects,
    tags,
    sequencerEngine,
    searchText,
    setSearchText,
    setSelectedEffect,
    setSelectedTag,
    selectedTag,
    selectedEffect,
    track,
    ref
}) => {

    useEffect(() => {
        clear();
    }, []);

    useEffect(() => {
        if (!searchText || searchText === undefined) {
            clear(false);
        }
    }, [searchText, setSearchText, setTags, setEffects, setSelectedTag]);

    const clear = useCallback((reload=true) => {
        setSearchText('');
        setTags(DEFAULT_TAGS);
        setEffects([]);
        setSelectedTag(undefined);
        setSelectedEffect(undefined);
        let track = sequencerEngine.getSelectedTrack();
        if (track && track.samplesStream && reload) {
            console.log("CLEAR BACK SAMPLES STREAM CALLED");
            // track.backSamplesStream();
        }
    }, [searchText, setSearchText, setTags, setEffects, setSelectedTag]);

    const onChange = useCallback(async (e) => {
        let text = e.target.value;
        setSearchText(text);
        let id = ++counter;
        if (text.trim() === '') {
            setSearchText("");
            setTags(DEFAULT_TAGS);
            setEffects([]);
            return;
        }

        setTimeout(() => {
            if (id !== counter) {
                return;
            }

            // set selected tag
            // what we want here is just to query the list of tags and find the best result
            getAllTags(text).then(
                tags => {
                    sequencerEngine.searchForSounds(
                       [tags[0]], true, track, false);
                    setSelectedTag(tags[0]);
                });
        }, WAIT_TIME);
        
        // search for tags with field searcher
    }, [setTags, setSearchText, setEffects, setSelectedTag, setSelectedEffect]);

    useEffect(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [
        setSearchText,
        tags,
        effects,
        selectedTag,
        selectedEffect,
        setSelectedTag,
        setSelectedEffect]);

    const onKeyDown = useCallback((e) => {
        if (e.target !== ref.current) {
            // only care if its coming from this search input
            return;
        }

        if (e.key === 'Enter') {
            if (selectedTag) {
                addTag(selectedTag, tags[selectedTag], sequencerEngine);
                clear();
                ref.current.blur();
            }
        } else if (e.key === 'ArrowDown') {
            if (selectedTag) {
                let keys = Object.keys(tags);
                let index = keys.indexOf(selectedTag);
                let _index = index + 1;
                if (_index < keys.length ){
                    setSelectedTag(keys[_index]);
                } else {
                    setSelectedTag(keys[0]);
                }
            } else if (selectedEffect) {
            }
        } else if (e.key === 'ArrowUp') {
            if (selectedTag) {
                let keys = Object.keys(tags);
                let index = keys.indexOf(selectedTag);
                let _index = index - 1;
                if (_index >= 0) {
                    setSelectedTag(keys[_index]);
                } else {
                    setSelectedTag(keys[_index.length - 1]);
                }
            }
        } else if (e.key === 'Escape') {
            ref.current.blur();
        }
    }, [
        setSearchText,
        tags,
        effects,
        selectedTag,
        selectedEffect,
        setSelectedTag,
        setSelectedEffect]);

    return {onChange, clear};
};

const searchForEffects = (str) => {
    // first check for presets
    str = str.toLowerCase();
    let names = Object.keys(nameToEffect);
    names = [... names, ... Object.keys(nameToMidiEffect)];
    let fx = names.filter(
        x => x.toLowerCase().includes(str));
    let obj = {};
    fx.forEach(e => obj[e] = [])
    return obj;
};

const searchForEffectPresets = async (str) => {
    if (!CACHED_PRESETS) {
        CACHED_PRESETS  = await getEffectPresets();
    }

    str = str.toLowerCase();
    let matchedPresets = CACHED_PRESETS.filter(
        x => x.title.toLowerCase().includes(str));
    if (matchedPresets.length === 0) {
        return undefined;
    }

    let obj = {};
    for (let preset of matchedPresets) {
        let {effectType} = preset;
        if (!(effectType in obj)) {
            obj[effectType] = [];
        }

        obj[effectType].push(preset);
    }
    return obj;
};
